const $count = (collection, _expr, _options) => collection.length;
export {
  $count
};
